<template>
    <div>
        <main v-cloak>
        <!-- <figure class="about-img2 img-wrapper">
          <img src="../../assets/static/images/illustrations/ecommerce.svg" />
        </figure> -->
        <p><button data-qa="stepByStepGuideButton" class="login-btn" sytle="text-transform: uppercase;" @click="toggleModal()">{{ $t('instructionsButton') }}</button></p>
            <!--  The Modal -->
            <boardal v-if="modal.isOpen" :has-mask="modal.hasMask" :can-click-mask="modal.canClickMask" :has-x="modal.hasX" @toggle="toggleModal">
                <article v-cloak>
                    <section>
                        <button class="bg" @click="finish()">&#10006;</button>
                        <h3>{{ $t('step1') }}</h3>
                        <div class="about-container">
                            <figure class="about-img img-wrapper">
                                <img src="../../assets/static/images/illustrations/company.svg" />
                            </figure>
                            <div class=text-wrapper>
                              <div class="about-text">
                                <h5>{{ $t('mandatory') }}</h5>
                                <hr/>
                                <p class="feature">&#10004;  {{ $t('step1-mandatory1') }}</p>
                                <p class="feature">&#10004;  {{ $t('step1-mandatory2') }}</p>
                                <p class="feature">&#10004;  {{ $t('step1-mandatory3') }}</p>
                                <p class="feature">&#10004;  {{ $t('step1-mandatory4') }}</p>
                                <p class="feature">&#10004;  {{ $t('step1-mandatory5') }}</p>
                                <p class="feature">&#10004;  {{ $t('step1-mandatory6') }}</p>
                              </div>
                              <div class="about-text">
                                <h6>{{ $t('recommended') }}</h6>
                                <hr/>
                                <p class="feature sm">&#10004;  {{ $t('step1-recommended1') }}</p>
                                <p class="feature sm">&#10004;  {{ $t('step1-recommended2') }}</p>
                              </div>
                              <div class="about-text">
                                <h6>{{ $t('optional') }}</h6>
                                <hr/>
                                <p class="feature xs">&#10004;  {{ $t('step1-optional1') }}</p>
                                <p class="feature xs">&#10004;  {{ $t('step1-optional2') }}</p>
                              </div>                              
                            </div>
                        </div>
                    </section>
                    <section>
                        <button class="bg" @click="finish()">&#10006;</button>
                        <h3>{{ $t('step2') }}</h3>
                        <div class="about-container">
                            <figure class="about-img img-wrapper">
                                <img src="../../assets/static/images/illustrations/team.svg" />
                            </figure>
                            <div class="about-text">
                              <h5>{{ $t('addTeamMember') }}</h5>
                              <hr/>
                                <p class="feature">&#10004;  {{ $t('step2-mandatory1') }}</p>
                                <p class="feature">&#10004;  {{ $t('step2-mandatory2') }}</p>
                                <p class="feature">&#10004;  {{ $t('step2-mandatory3') }}</p>
                            </div>
                        </div>
                        <!-- <p><button class="primary" @click="goToStep(5)">skip to the end</button></p>
                        <p><button class="primary" @click="toggleModal">Bail Out!</button></p>
                        <p><button class="primary" @click="skip(1)">Next...</button></p>
                        <p><button @click="reset()">Rewind</button></p> -->
                    </section>
                    <section>
                        <button class="bg" @click="finish()">&#10006;</button>
                        <h3>{{ $t('step3') }}</h3>
                        <div class="about-container">
                            <figure class="about-img img-wrapper">
                                <img src="../../assets/static/images/illustrations/unit.svg" />
                            </figure>
                            <div class=text-wrapper>
                              <div class="about-text">
                                <h5>{{ $t('mandatory') }}</h5>
                                <hr/>
                                <p class="feature">&#10004;  {{ $t('step3-mandatory1') }}</p>
                                <p class="feature">&#10004;  {{ $t('step3-mandatory2') }}</p>
                              </div>
                              <div class="about-text">
                                <h6>{{ $t('recommended') }}</h6>
                                <hr/>
                                <p class="feature sm">&#10004;  {{ $t('step3-recommended1') }}</p>
                              </div>
                              <div class="about-text">
                                <h6>{{ $t('optional') }}</h6>
                                <hr/>
                                <p class="feature xs">&#10004;  {{ $t('step3-optional1') }}</p>
                                <p class="feature xs">&#10004;  {{ $t('step3-optional2') }}</p>
                              </div>                              
                            </div>
                        </div>
                    </section>
                    <section>
                        <button class="bg" @click="finish()">&#10006;</button>
                        <h3>{{ $t('step4') }}</h3>
                        <div class="about-container">
                            <figure class="about-img img-wrapper">
                                <img src="../../assets/static/images/illustrations/product.svg" />
                            </figure>
                            <div class="about-text">
                              <h5>{{ $t('mandatory') }}</h5>
                              <hr/>
                              <p class="feature">&#10004;  {{ $t('step4-mandatory1') }}</p>
                              <p class="feature">&#10004;  {{ $t('step4-mandatory2') }}</p>
                              <p class="feature">&#10004;  {{ $t('step4-mandatory3') }}</p>
                              <p class="feature">&#10004;  {{ $t('step4-mandatory4') }}</p>
                              <p class="feature">&#10004;  {{ $t('step4-mandatory5') }}</p>
                            </div>
                        </div>
                    </section>
                    <section>
                        <button class="bg" @click="finish()">&#10006;</button>
                        <h3>{{ $t('step5') }}</h3>
                        <div class="about-container">
                            <figure class="about-img img-wrapper">
                                <img src="../../assets/static/images/illustrations/supplier.svg" />
                            </figure>
                            <div class=text-wrapper>
                              <div class="about-text">
                                <h5>{{ $t('mandatory') }}</h5>
                                <hr/>
                                <p class="feature">&#10004;  {{ $t('step5-mandatory1') }}</p>
                              </div>
                              <div class="about-text">
                                <h6>{{ $t('recommended') }}</h6>
                                <hr/>
                                <p class="feature sm">&#10004;  {{ $t('step5-recommended1') }}</p>
                                <p class="feature sm">&#10004;  {{ $t('step5-recommended2') }}</p>
                                <p class="feature sm">&#10004;  {{ $t('step5-recommended3') }}</p>
                                <p class="feature sm">&#10004;  {{ $t('step5-recommended4') }}</p>
                              </div>
                            </div>
                        </div>
                    </section>
                    <section>
                        <button class="bg" @click="finish()">&#10006;</button>
                        <h3>{{ $t('step6') }}</h3>
                        <div class="about-container">
                            <figure class="about-img img-wrapper">
                                <img src="../../assets/static/images/illustrations/product.svg" />
                            </figure>
                            <div class=text-wrapper>
                              <div class="about-text">
                                <h5>{{ $t('mandatory') }}</h5>
                                <hr/>
                                <p class="feature">&#10004;  {{ $t('step6-mandatory1') }}</p>
                                <p class="feature">&#10004;  {{ $t('step6-mandatory2') }}</p>
                                <p class="feature">&#10004;  {{ $t('step6-mandatory3') }}</p>
                                <p class="feature">&#10004;  {{ $t('step6-mandatory4') }}</p>
                                <p class="feature">&#10004;  {{ $t('step6-mandatory5') }}</p>
                                <p class="feature">&#10004;  {{ $t('step6-mandatory6') }}</p>
                              </div>
                              <div class="about-text">
                                <h6>{{ $t('recommended') }}</h6>
                                <hr/>
                                <p class="feature sm">&#10004;  {{ $t('step6-recommended1') }}</p>
                                <p class="feature sm">&#10004;  {{ $t('step6-recommended2') }}</p>
                              </div>
                              <div class="about-text">
                                <h6>{{ $t('optional') }}</h6>
                                <hr/>
                                <p class="feature xs">&#10004;  {{ $t('step6-optional1') }}</p>
                              </div>                              
                            </div>
                        </div>
                    </section>
                    <section>
                        <button class="bg" @click="finish()">&#10006;</button>
                        <h3>{{ $t('step7') }}</h3>
                        <div class="about-container">
                            <figure class="about-img img-wrapper">
                                <img src="../../assets/static/images/illustrations/ecommerce.svg" />
                            </figure>
                            <div class=text-wrapper>
                              <div class="about-text">
                                <h5>{{ $t('mandatory') }}</h5>
                                <hr/>
                                <p class="feature">&#10004;  {{ $t('step7-mandatory1') }}</p>
                                <p class="feature">&#10004;  {{ $t('step7-mandatory2') }}</p>
                                <p class="feature">&#10004;  {{ $t('step7-mandatory3') }}</p>
                              </div>
                              <div class="about-text">
                                <h6>{{ $t('recommended') }}</h6>
                                <hr/>
                                <p class="feature sm">&#10004;  {{ $t('step7-recommended1') }}</p>
                              </div>
                            </div>
                        </div>
                    </section>
                    <section>
                        <button class="bg" @click="finish()">&#10006;</button>
                        <h3>{{ $t('step8') }}</h3>
                        <div class="about-container">
                            <figure class="about-img img-wrapper">
                                <img src="../../assets/static/images/illustrations/QRscanning2.svg" />
                            </figure>
                            <div class="about-text">
                              <p class="feature">&#10004;  {{ $t('step8-mandatory1') }}</p>
                              <p class="feature">&#10004;  {{ $t('step8-mandatory2') }}</p>
                              <p class="feature">&#10004;  {{ $t('step8-mandatory3') }}</p>
                              <br/>
                              <p class="feature large"> {{ $t('step8-mandatory4') }}</p>
                            </div>
                        </div>
                    </section>
                </article>
                <footer>
                    <div class="forward-actions">
                <!--         <button class="secondary skip" :disabled="isLastStep" v-show="!isLastStep" @click="skip(2)">Skip</button> -->
                        <button class="primary next" :disabled="isLastStep" v-show="!isLastStep" @click="skip(1)"><i class="fa fa-fw fa-lg" :class="nextIcon"></i></button>
                        <button class="accent save" :disabled="!isLastStep" v-show="isLastStep" @click="finish"><i class="fa fa-fw fa-lg fa-check"></i></button>
                    </div>
                    <div class="step-dots" v-if="hasDots">
                        <div v-bind:key="n" class="step-dot" v-for="n in max" :class="{active: n == step}" @click="goToStep(n)"></div>
                    </div>
                    <div class="back-actions">
                        <button class="secondary cancel prev" :disabled="isFirstStep" xv-show="!isFirstStep" @click="skip(-1)"><i class="fa fa-fw fa-lg" :class="backIcon"></i></button>
                    </div>
                </footer>
            </boardal>
        </main>
    </div>
</template>

<script>
import boardal from '@/components/common/Boardal.vue'

  export default {
name: 'instructions',
components: { 
     boardal
 },
data() {
    return {
    modal: {
      isOpen: false,
      hasMask: true,
      canClickMask: false,
      hasX: false
    },
    step: 1,
    max: 1,
    showDots: true,
    orientation: 'column',
    // xray: 'hidden'
  }
},
  computed: {
    isFirstStep: function(){
      return (this.step === 1)
    },
    isLastStep: function(){
      return (this.step === this.max)
    },
    hasDots: function(){
      return (this.max > 1 && this.showDots)
    },
    x_multiplier: function(){
      return (this.orientation === 'row' ? -1 : 0)
    },
    y_multiplier: function(){
      return (this.orientation === 'row' ? 0 : -1)
    },
    axis: function() {
      return (this.orientation === 'row' ? 'row' : 'column')
    },
    axisReverse: function() {
      return (this.orientation === 'row' ? 'row-reverse' : 'column-reverse')
    },
    cross: function() {
      return (this.orientation === 'row' ? 'column' : 'row')
    },
    crossReverse: function() {
      return (this.orientation === 'row' ? 'column-reverse' : 'row-reverse')
    },
    nextIcon: function() {
      return (this.orientation === 'row' ? 'fa-arrow-right' : 'fa-arrow-down')
    },
    backIcon: function() {
      return (this.orientation === 'row' ? 'fa-arrow-left' : 'fa-arrow-up')
    },
    
  },
  watch: {
    orientation: 'setCssVars',
    // xray: 'setCssVars'
  },
  methods: {
    toggleModal: function(step) {
      step = step || 1
      this.modal.isOpen = !this.modal.isOpen
      if(this.modal.isOpen) {
        let self = this
        setTimeout(function(){
          self.$sections = self.$el.querySelectorAll('section')
          self.max = self.$sections.length
          self.goToStep(step)
        }, 1)
      }
    },
    setCssVars: function(){
      this.$el.style.setProperty('--x', (((this.step * 100) - 100) * this.x_multiplier) + '%')
      this.$el.style.setProperty('--y', (((this.step * 100) - 100) * this.y_multiplier) + '%')
      this.$el.style.setProperty('--axis', this.axis)
      this.$el.style.setProperty('--axis-reverse', this.axisReverse)
      this.$el.style.setProperty('--cross', this.cross)
      this.$el.style.setProperty('--cross-reverse', this.crossReverse)
      // this.$el.style.setProperty('--vision', this.xray)
    },
    goToStep: function(step){
      this.step = step > this.max ? this.max : step < 1 ? 1 : step
      this.currentSection = this.$sections[this.step-1]
      this.$sections.forEach(function(section){
        section.classList.remove('current')
      })
      this.currentSection.classList.add('current')
      this.currentSection.scrollTop = 0
      this.setCssVars()
    },
    skip: function(step){
      this.step+=step
      this.goToStep(this.step)
    },
    reset: function(){
      this.goToStep(1)
    },
    finish: function(){
      this.toggleModal()
    }
  } 
  }
</script>

<style lang="scss" scoped>

:root {
  --accent: red !important; //not working//
}

/* tab setting */
$tab-count: 4;
$indicator-width: 50px;
$indicator-height: 4px;
/* breakpoints */
$breakpoints: (
  medium: #{$tab-count*250px},
  small: #{$tab-count*150px}
);

.img-wrapper {
  width: auto;
  position: relative;
}
.img-wrapper > img {
  position: relative;
}
.about-img {
  display: inline-block;
  width: 100%;
  max-width: 300px;
  text-align: center;
  vertical-align: top;
}
.about-img2 {
  display: inline-block;
  width: 100%;
  max-width: 500px;
  text-align: center;
  vertical-align: top;
}
.about-img img {
    width: 100%;
}

.feature {
  margin-bottom: 10px;
}

.large {
  font-weight: 600;
}

.login-btn{
  color: var(--primary) !important;
  border: 1px solid var(--primary);
  background: none;
  text-decoration: none;
  text-transform: uppercase;
  font-weight: 500;
  letter-spacing: 2px;
  padding: 10px 20px;
  border-radius: 5px;
  transition: 0.3s;
  transition-property: background;
}

.login-btn:hover{
  background: var(--primary);
  color: var(--bright) !important;
}

.about-text {
  display: inline-block;
  max-width: 500px;
  text-align: left;
  margin-top: 5px;
  margin-left: 50px;
  padding: 5px;
  margin: 5px;
  line-height: 0.8;
}

.about-text h5 h6 {
  font-weight: 600;
}

[v-cloak] {
  display: none;
}

.sm {
  font-size: 0.85em;
}

.xs {
  font-size: 0.75em;
}
// modal content sliders
article {
  flex: 1 1 100%;
  height: 100%;
  display: flex;
  flex-direction: var(--axis, row);
  overflow: hidden;
}
section {
  width: 100%;
  visibility: hidden;
  flex: 0 0 100%;
  padding: 1em;
  overflow: auto;
  will-change: transform;
  transform: translate(var(--x, 0%), var(--y, 0%));
  transition: transform 300ms ease-out;
  position: relative;
  h2,h3,h4 {
    margin-top: 0;
  }
  &.current {
    visibility: visible;
  }
}

section h3 {
  margin-top: 1.5em;
  font-weight: 600;
}

footer {
  position: relative;
  text-align: right;
  display: flex;
  flex-direction: var(--axis-reverse, row-reverse);
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 0 0 1px rgba(#000, .1);
  background: rgba(#000, .05);
  &:not(:empty) {
    padding: 0.5em;
  }
}

.step-dots {
  display: flex;
  flex-direction: var(--axis, row);
}
.step-dot {
  cursor: pointer;
  width: 1em;
  height: 1em;
  margin: .5ch;
  border-radius: 1em;
  background: currentColor;
  opacity: .2;
  transition: transform 100ms ease-out, opacity 150ms linear;
  &.active {
    opacity: .7;
    box-shadow: 0 0 1em -.25em;
  }
  &:hover {
    transform: scale(1.2)
  }
}
.forward-actions,
.back-actions {
  flex: 1;
  display: flex;
  flex-direction: var(--axis, row);
}
.forward-actions {
  justify-content: flex-end;
  // text-align: right;
}
.back-actions {
  justify-content: flex-start;
  // text-align: left;
}

// boring
*, *::before, *::after {box-sizing: border-box;}

a {
  color: var(--accent);
}

del {
  color: #ca1e34;
  font-style: italic;
}

p {
  line-height: 1.5;
}

body {
  margin: 0;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: sans-serif;
  background: snow;
  color: #333;
}

// broadal buttons
button {
  outline: none;
  font: inherit;
  line-height: 1;
  cursor: pointer;
  padding: .5em 1em;
  border-radius: .35em;
  color: rgba(#000, .7);
  background: rgba(#000, .1);
  border: 2px solid rgba(#000, .05);
  text-shadow: 0 1px 0 rgba(#fff, .4);
  transition: transform 50ms ease-out;
  will-change: transform;
  &:active {
    transform: scale(.95);
  }
  &:focus {
    border-color: var(--accent);
    box-shadow: 0 0 1em 0 var(--accent);
  }
  &[disabled] {
    opacity: .2;
    cursor: not-allowed;
  }
  &.primary {
    border-color: transparent;
    background: transparent;
    font-weight: bold;
    &:not([disabled]) {
      color: var(--accent);
    }
  }
  &.accent {
    background: var(--accent);
    &:not([disabled]) {
      color: #fff;
    }
  }
  &.secondary {
    border-color: transparent;
    background: transparent;
    &:not([disabled]) {
      color: rgba(#000, .4);
    }
  }
  &.cancel:not([disabled]) {
    color: var(--accent);
  }
}

 @media (max-width: map-get($breakpoints, small)) {
    .about-container {
    text-align: left;
  }
  .about-img {
    padding: 0em;
    margin: 5px;
    vertical-align: top;
    max-width: 170px;
  }
  .about-text {
    display: inline-block;
    /* max-width: 400px; */
    text-align: left;
    line-height: 0.5;
    font-size: 0.8em;
    width: 100%;
  }
  .feature {
    margin-bottom: 1px;
  }
  .accent {
    width: 80%
  }
section h3 {
  font-size: 1.35rem;
  margin-top: 0.2em;

}
 }

 @media (min-width: map-get($breakpoints, small)) {
.about-container {
  text-align: center;
}
.text-wrapper {
    display: flex;
    position: absolute;
    left: 20%;
}
 }
</style>